import React, { useState } from 'react';
import type { WindowSize } from '../types';

export function useWindowSize(): WindowSize {
  const isSSR = typeof window === 'undefined';
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 1200,
    height: 800,
  });

  function changeWindowSize() {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }

  React.useEffect(() => {
    if (isSSR) return undefined;

    const animationFrame = window.requestAnimationFrame(changeWindowSize);
    window.addEventListener('resize', changeWindowSize);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', changeWindowSize);
    };
  }, [isSSR]);

  return windowSize;
}
